import { useSelector } from 'react-redux';
import { selectDealType } from '../../../selectors/page';
import { EDealType } from '../../../types/dealType';

export const useAuthErrorTitle = (): string => {
  const dealType = useSelector(selectDealType);

  return dealType === EDealType.Sale
    ? ', чтобы просматривать снятые с продажи объявления'
    : ', чтобы просматривать снятые с публикации объявления';
};
